// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"table_tableContainer__26Ew_","table":"table_table__1hvLk"};